var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"button text",on:{"click":_vm.openDropdown}},[_c('span',[_vm._v(_vm._s(_vm.language))]),_vm._v(" "),_c('span',{staticClass:"icon arrow-down-small"})])
}
var staticRenderFns = []

export { render, staticRenderFns }